import React, { useState } from 'react';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-brand-200">
      <button 
        className="w-full py-4 text-left flex justify-between items-center focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-lg font-medium text-brand-900">{question}</span>
        <span className="text-2xl text-brand-500 font-light">{isOpen ? '−' : '+'}</span>
      </button>
      <div 
        className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-4' : 'max-h-0'}`}
      >
        <p className="text-brand-600 leading-relaxed">{answer}</p>
      </div>
    </div>
  );
};

const FAQ = () => {
  const faqs = [
    {
      q: "Can I park there?",
      a: "Free private parking is available on site (reservation is required)."
    },
    {
      q: "What are the check-in and check-out times?",
      a: "Check-in is from 12:00 to 17:00. Check-out is until 12:00. If you want early or late check-in/check-out, you can request it during booking. Please note special requests cannot be guaranteed. If early/late check-in or check-out is essential for your plans, please review cancellation options before booking."
    },
    {
      q: "Is breakfast available?",
      a: "Select your travel dates and view the available rooms to see whether breakfast options are available."
    },
    {
      q: "Can I bring my pet?",
      a: "Unfortunately, pets are not allowed."
    },
    {
      q: "Is there a restaurant?",
      a: "Yes, there is an on-site restaurant at Amani Palms by Manolo Beach Resort."
    },
    {
      q: "Are there rooms with a balcony?",
      a: "No, the property does not offer rooms with balconies."
    },
    {
      q: "Is the pool open?",
      a: "Yes, there is a pool at the property."
    },
    {
      q: "Is the wellness area open?",
      a: "Yes, there is a spa or wellness center at the property."
    },
    {
      q: "What restaurants, attractions and public transport are nearby?",
      a: "Use the “Activities & Surroundings” section and contact us if you would like tailored recommendations."
    },
    {
      q: "Do the rooms have a private bathroom?",
      a: "Yes, rooms with a private bathroom are available. Select your travel dates to ensure this facility is available for your room choice."
    }
  ];

  return (
    // Increased top padding from pt-24 to pt-36
    <div className="page-transition pt-36 pb-20">
      <div className="container mx-auto px-6 max-w-3xl">
        <h1 className="text-4xl md:text-5xl mb-12 text-center">Frequently Asked Questions</h1>
        <div className="space-y-2">
          {faqs.map((faq, idx) => (
            <FAQItem key={idx} question={faq.q} answer={faq.a} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;